import { Button, Result } from 'antd';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const FourZeroFour = () => {
  const { t } = useTranslation();

  return (
    <Result
      status={404}
      title={'404'}
      subTitle={t('404.description')}
      extra={
        <Link to={'/front'}>
          <Button type='primary'>{t('404.backToDashboard')}</Button>
        </Link>
      }
    />
  );
};
